import { GrayBackground, Image, soundManager, useVoucherStore } from '@slot-nx/core'
import { Container } from '@pixi/react'
import { VoucherSelectPopupTitle } from './VoucherSelectPopupTitle'
import { VoucherSelectPopupContent } from './VoucherSelectPopupContent'
import { VoucherSelectPopupTime } from './VoucherSelectPopupTime'
import { VoucherSelectPopupButtons } from './VoucherSelectPopupButtons'
import { memo, useEffect, useRef } from 'react'
import { Container as PixiContainer } from 'pixi.js'
import gsap from 'gsap'
import { VoucherSoundType } from '../../../domain/soundManager/enum/VoucherSoundType'
export function showPopupAnimation(popupRef: PixiContainer) {
  gsap.set(popupRef, { alpha: 0, scale: 0.8 })
  gsap.to(popupRef.scale, {
    x: 1,
    y: 1,
    ease: 'back.out(1.7)',
    duration: 0.5,
  })
  gsap.to(popupRef, {
    alpha: 1,
    duration: 0.5,
  })
}

export const VoucherSelectPopup = memo(() => {
  const [isShowVoucherPopup, remainSpin, expireDate] = useVoucherStore(x => [x.isShowVoucherSelectPopup, x.remainSpin, x.expireDate])
  const popupRef = useRef<PixiContainer>()

  useEffect(() => {
    if (isShowVoucherPopup && popupRef.current) {
      soundManager.play(VoucherSoundType.selectPopup)
      showPopupAnimation(popupRef.current)
    }
  }, [isShowVoucherPopup])

  return (
    <Container name="VoucherSelectPopupWrapper" visible={isShowVoucherPopup}>
      <GrayBackground name="VoucherPopup_Bg">
        <Container x={540} y={960} name="VoucherSelectPopup" ref={(el) => { popupRef.current = el as PixiContainer }}>
          <Image name="voucher_popup"image="voucher_Pop-up"width={942}height={1344}anchor={[0.5, 0.5]}x={0}y={0} />
          <VoucherSelectPopupTitle totalRounds={remainSpin} />
          <VoucherSelectPopupContent />
          <VoucherSelectPopupTime expireTime={expireDate} />
          <VoucherSelectPopupButtons />
        </Container>
      </GrayBackground>
    </Container>
  )
})
